"use client"

import { usePathname } from "next/navigation"
import { ReactNode, useEffect } from "react"

export default function ClientLayout({ children }: { children: ReactNode }) {
  const pathname = usePathname()

  /**
   * This is a bit hacky.
   *
   * In NextJS if you navigate from the landing page to another
   * layout that has a ThemeProvider, then theme will persist.
   *
   * We do NOT want the landing page to be in dark mode,
   * so this removes the dark mode elem from the html element.
   */
  useEffect(() => {
    const html = document.documentElement

    html.classList.remove("dark")
    html.style.removeProperty("color-scheme")
  }, [pathname])

  return <>{children}</>
}
